import { UserManagerSettings } from "oidc-client";
import { MedsUserManager } from "../features/auth/MedsUserManager";
import { logger } from "../features/common/logger";
import { configureMedications } from '@communicare/medications/Config/ApplicationConfig';
import { getApiConfig } from "./api.config";
import { getConfig } from "..";

type storageKey = 'providerId'

let userManager: MedsUserManager;
let loginTimeout: number;
let retryCount: number;
let retryWaitTime: number;
let config: UserManagerSettings;

export function configureAuth(settings: any) {  
    config = {
    client_id: settings.authentication.clientId,
    redirect_uri: settings.authentication.redirectUrl,
    authority: settings.authentication.authority,
    response_type: 'id_token token',
    scope: `openid profile email ${settings.authentication.additionalScopes}`,
    automaticSilentRenew: (settings?.authentication?.automaticSilentRenew || true),
    loadUserInfo: false,
    post_logout_redirect_uri: `${settings.authentication.redirectUrl}logout`,
    silent_redirect_uri: `${settings.authentication.redirectUrl}renew.html`,
    //This value is to notify 2 minutes before if token is expiring. So, it wiil refresh the token 2 minutes before to avoid any errors.  
    accessTokenExpiringNotificationTime: 120,
    extraQueryParams: {
      "audience": ""
    }
  }
  
  userManager = new MedsUserManager(config, false);
  //This event is required to call renew.html while expiring token. Please don't remove this event.
  userManager.events.addAccessTokenExpiring(() => {
    console.log("The access token is expiring");
  });
  loginTimeout = (settings?.authentication?.loginTimeout || 60) * 60 * 1000;
  retryCount = settings?.authentication?.retryCount;
  //The config value for wait time is in seconds and the wait time should be in milliseconds. 
  //So, converting the config time to millisencds.
  retryWaitTime = (settings?.authentication?.retryWaitTime || 6) * 1000;
}

export function getUserManager(isClinicalIdentityProviderUser?: boolean) {    
  userManager = new MedsUserManager(config, isClinicalIdentityProviderUser);
  return userManager;
}

export function addToStorage(key: storageKey, val: string) {
  localStorage.setItem(key, val)
}

export function getFromStorage(key: storageKey) {
  return localStorage.getItem(key)
}

export function removeFromStorage(key: storageKey) {
  return localStorage.removeItem(key)
}

export async function getAuthAccessToken() {
  let user = await userManager.getUser();

  if (user) {
    return user?.access_token;
  }

  logger.log('Cannot find access token as no user stored');
  return '';
}

export function getLoginTimeout() {
  return loginTimeout;
}

export function getAuthenticationRetryConfig(): [number, number] {
  return [retryCount, retryWaitTime];
}

export function configureMedicationSettings(isClinicalIdentityProviderUser?: boolean) {
  getConfig().then(res => {
    let apiEndPoints = getApiConfig();
    let userManager = getUserManager(isClinicalIdentityProviderUser);
    configureMedications({
      appConfig: {
        apiEndpoints: {
          authorisation: apiEndPoints.url.authorisation,
          medicationsManagement: apiEndPoints.url.medicationsManagement
        },
        authentication: {
          additionalScopes: res.authentication.additionalScopes,
          authority: res.authentication.authority,
          clientId: res.authentication.clientId,
          redirectUrl: res.authentication.redirectUrl,
          loadUserInfo: "",
          extraQueryParams: {}
        },
        cookieCheck: {
          url: res.cookieCheck.url
        },
        customerInfo: "",
        environmentInfo: "",
        automaticLogoutMinutes: 60
      },
      userManager: userManager
    });
  });
}